export default __webpack_public_path__ + "static/media/news173.430c1b28.jpg";